import { Link } from 'react-router-dom';

const PaymentCancelPage = () => {
  return (
    <div className="h-screen bg-gray-50 flex flex-col items-center justify-center px-4 font-sans">
      <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-5">
          <svg className="w-8 h-8 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Cancelled</h1>
        <p className="text-gray-600 mb-6">
          No worries! You were not charged. You can choose a plan whenever you're ready.
        </p>
        <div className="flex flex-col gap-3">
          <Link
            to="/pricing"
            className="inline-block w-full py-3 bg-ag-black-800 text-white rounded-full font-semibold hover:bg-ag-black-700 transition-colors"
          >
            View Plans
          </Link>
          <Link
            to="/dashboard"
            className="inline-block w-full py-3 text-gray-600 hover:text-gray-900 transition-colors text-sm"
          >
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
